// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"a9d0ac28","144":"d7e70cc5"}[chunkId] + ".chunk.css";
};